import WC from "../common/WebcomponentCreator"

import "../css/multiSelect.css"
import styles from "styles-to-js-loader/styles";
class multiSelect extends WC {
    static get observedAttributes() {
        return super.observedAttributes.concat("disabled", "defaultlabel");
    }
    constructor() {
        const template = document.createElement("div");
        template.setAttribute("class", "template");
        super(template, { shadowMode: "closed" });
        this.getShadow().appendChild(styles.get());

        this.dropdown = document.createElement("div");
        this.dropdown.setAttribute("class", "dropdown");
        template.appendChild(this.dropdown);

        this.dropdownContent = document.createElement("div");
        this.dropdownContent.setAttribute("class", "dropdown-content");
        this.dropdownContent.classList.add("closed");
        template.appendChild(this.dropdownContent);

        this.label = document.createElement("label");
        this.label.setAttribute("class", "label-multi-select")
        this.label.setAttribute("for", "dropdown");
        this.dropdown.appendChild(this.label);

        this.data = [];
        this.selectedValues = [];
        this.defaultLabel = "default"

        //Clicking dropdownbutton, toggle options list
        this.dropdown.addEventListener("click", (e) => {
            this.toggle.bind(this)(e);
        })
        //When clicking outside the dropdown and it is open, close it.
        window.addEventListener("click", (e) => {
            if (!this.isClosed()) {
                this.close();
            }
        })
        //This is here because when clicking the dropdownContent it triggers the windows click event, hence we need to stop propogation.
        this.dropdownContent.addEventListener("click", e => {
            e.stopPropagation();
        });
    }

    //Toggles the dropdown content to show or not. Creates the option list dynamically when showing.
    toggle(e) {
        e.stopPropagation();
        if (this.dropdown.getAttribute("disabled") !== "true") {
            if (this.isClosed()) {
                this.data?.forEach(({ name, value }) => {
                    this.dropdownContent.appendChild(this.createOption(name, value));
                });
                this.dropdownContent.classList.remove("closed");
                this.updateOptionSelection(true);
            }
            else {
                this.close();
            }
        }
    }

    //Used outside the component when user clicks the reset button in filter.
    reset() {
        this.selectedValues = [];
        this.updateOptionSelection();
    }

    createOption(name, value) {
        let o = document.createElement("div");
        o.className = "multi-select-option";
        o.value = value;
        o.innerHTML = name;
        o.addEventListener("click", (e) => {
            e.stopPropagation();
            if (this.selectedValues.includes(e.target.value))
                this.selectedValues = this.selectedValues.filter(value => value !== e.target.value);
            else
                this.selectedValues.push(e.target.value);
            this.updateOptionSelection();
        });
        return o;
    }

    isClosed() {
        return this.dropdownContent.classList.contains("closed");
    }

    //Close the dropdown
    close() {
        this.dropdownContent.classList.add("closed");
        while (this.dropdownContent.firstChild)
            this.dropdownContent.removeChild(this.dropdownContent.firstChild);
    }

    //When setting specific dom attributes.
    attributeChangedCallback(name, oldVal, newVal) {
        if (oldVal !== newVal) {
            if (name === "disabled") {
                this.dropdown.setAttribute("disabled", newVal)
                this.selectedValues = [];
                this.label.innerHTML = this.defaultLabel;
                this.updateOptionSelection(true);
                this.close();
            }
            else if (name === "defaultlabel") {
                this.defaultLabel = newVal;
                this.label.innerHTML = this.defaultLabel;
            }
        }
    }

    //Used whenever we update selectedValues, i.e after user clicks an option or user resets filter.
    // Pass silent=true for programmatic updates that should not notify listeners.
    updateOptionSelection(silent = false) {
        let list = this.dropdownContent.children;
        for (let i = 0; i < list.length; i++)
            if (this.selectedValues.includes(list[i].value))
                list[i].setAttribute("selected", true);
            else
                list[i].setAttribute("selected", false);
        this.label.innerHTML = this.selectedValues.length > 0
            ? "Antal valda: " + (this.selectedValues.length)
            : this.defaultLabel;
        if (!silent) {
            this.dispatchEvent(new Event("change"));
        }
    }

    //Useful when we want to access value outside this component.
    get value() {
        return this.selectedValues;
    }
    set value(val) {
        // Check if val is an array
        this.selectedValues = val;
        this.updateOptionSelection()
    }
    //Might be useful.
    get options() {
        //Return everything in child
        var res = [];
        this.data?.forEach(({ name, value }) => {
            res.push(this.createOption(name, value));
        });
        return res;
    }

    //Useful when accessing attributes outside the component.
    get selectedIndex() {
        let res = [];
        for (var i = 0; i < this.data.length; i++) {
            if (this.selectedValues.includes(this.data[i].value)) {
                res.push(i);
            }
        }
        return res;
    }
}

if (!customElements.get('multi-select')) {
if (!customElements.get("multi-select")) {
        WC.define("multi-select", multiSelect);
}
}
